import React from "react";
import { useContext } from "react";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";
import { MemoryTimerContext } from "../Context/MemoryTimerContext";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";
import useMediaQuery from "../Hooks/useMediaQuery";

const QuitGameButton = () => {

    const isSmallScreen = useMediaQuery('(max-width: 1080px)');
    const {unsetLevels, handleShuffleCards, handleMemoryCompleted} = useContext(MemoryLevelContext);
    const {handleTimer, resetTime} = useContext(MemoryTimerContext);
    const {handleShowCounter, updateCountDown} = useContext(MemoryCountDownContext);
    // const {handleShuffleCards, handleMemoryCompleted} = useContext(MemoryGameContext);

    const quitGame = () => {
        unsetLevels(false);
        handleTimer(false);
        resetTime();
        handleShowCounter(true);
        updateCountDown(false);
        handleMemoryCompleted(false);
        handleShuffleCards();
        document.documentElement.style.setProperty("--wrapper-height", `${isSmallScreen ? "760px" : "800px"}`);
    };

    return(
        <span className="button-container">
            <button className="game-button game-button-back" onClick={() => quitGame()}>
                <span className="label">Avsluta</span>
            </button>
        </span>
    );
};

export default QuitGameButton;